import { ConfigureParams } from "fleet/view/configure-params";
import get from "lodash/get";
import PropTypes from "prop-types";
import React from "react";
import Alert from "react-bootstrap/Alert";
import { Link } from "react-router-dom";
import * as Device from "redux-store/devices/selectors";
import { NavLoader } from "ui/loader";
import { PRIORITY } from "ui/parameter-form/utils";
import { RefreshView } from "ui/refresh-view";

class ConfigureDeviceParams extends React.PureComponent {
  static get propTypes() {
    return {
      addErrorMessage: PropTypes.func.isRequired,
      apps: PropTypes.array.isRequired,
      device: PropTypes.object.isRequired,
      network: PropTypes.object,
      readonly: PropTypes.bool.isRequired,
      updateParams: PropTypes.func.isRequired,
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      refresh: false,
    };

    this.updateParams = this.updateParams.bind(this);
  }

  getDeviceParams() {
    const { device } = this.props;

    return get(device, "user_params", []);
  }

  updateParams(params) {
    const { device, updateParams } = this.props;

    return updateParams({
      params,
      id: device.id,
    }).then(() => {
      this.setState({ refresh: true });
    });
  }

  render() {
    const { device, network } = this.props;

    const { refresh } = this.state;
    if (refresh) {
      return <RefreshView />;
    }

    if (!network) {
      return <NavLoader.Proxy />;
    }

    // Ensure state is correct, so downstream components don't suffer
    // synchronization problems.
    if (device.network_id !== network.id) {
      return <NavLoader.Proxy>Syncing device network...</NavLoader.Proxy>;
    }

    const isTesting = Device.isTesting(device);
    const successLink = (
      <Link to={`/devices/${device.device_id}/overview`}>View Device</Link>
    );
    const systemManagedParams = Device.getSystemManagedParams(device);
    const deviceParams = this.getDeviceParams();

    return (
      <div>
        <Alert className="alert-muted small-alert">
          <i className="fa fa-info-circle" aria-hidden="true" />
          <span className="font-smaller">
            You&#39;re currently configuring a single device. To configure all
            devices for this network, you may configure the&nbsp;
            <Link to={`/networks/${network.id}/configure`}>network level</Link>
            &nbsp;instead.
          </span>
        </Alert>
        <ConfigureParams
          {...this.props}
          deviceParams={deviceParams}
          onSubmit={this.updateParams}
          priority={PRIORITY.DEVICE}
          showTestingApps={isTesting}
          successLink={successLink}
          systemManagedParams={systemManagedParams}
        />
      </div>
    );
  }
}

export { ConfigureDeviceParams };
